//View Keys
export default {
	templateList_firstName: 'First Name',
	templateList_lastName: 'Last Name',
	templateList_unit: 'Unit',
	templateList_cretedOn: 'Created On',

	templateList_otherActions: 'Other Actions',
};
